import { atom } from 'jotai';
import { User as FirebaseUser } from 'firebase/auth';
import { User, UserSettings } from '@/types';

// Firebase Auth user (undefined = loading, null = not authenticated)
export const firebaseUserAtom = atom<FirebaseUser | null | undefined>(undefined);

// Full user profile from Firestore (undefined = not fetched yet, null = no profile)
export const userAtom = atom<User | null | undefined>(undefined);

// Track if we're currently fetching the user profile
export const isLoadingUserProfileAtom = atom<boolean>(false);

// Derived atoms
export const isAuthenticatedAtom = atom((get) => {
  const firebaseUser = get(firebaseUserAtom);
  return firebaseUser !== undefined && firebaseUser !== null;
});

export const isLoadingAuthAtom = atom((get) => {
  const firebaseUser = get(firebaseUserAtom);
  return firebaseUser === undefined;
});

export const userSettingsAtom = atom((get) => {
  const user = get(userAtom);
  return user?.settings;
});

export const themeAtom = atom((get) => {
  const settings = get(userSettingsAtom);
  return settings?.theme ?? 'light';
});
